export const handleChangeCustomName = (names, onChange) => {
  onChange({
    name: {
      ...names,
    },
  })
}
